import type { CalibNormMap } from './RemoteDisplayState.ts';
import type { RemoteViewLayout } from 'shared/lib/tv-game/nativeLayout.ts';
import type { TrailPoint } from './GameState.ts';

export type IqPhase = 'lobby' | 'calibrating' | 'playing' | 'paused' | 'gameover';

export interface IqAnswerRow {
  id: string;
  nx: number;
  ny: number;
  nw: number;
  nh: number;
  text: string;
  backgroundColor: string;
}

export interface IqLabelRow {
  text: string;
  nx: number;
  ny: number;
  color: string;
  alpha: number;
}

export interface IqDisplayState {
  phase: IqPhase;
  score: number;
  progress: string;
  timeLeft: number | null;
  question: string;
  answers: IqAnswerRow[];
  labels: IqLabelRow[];
  answerTextSize: number;
  calibNormPoints: CalibNormMap;
  detectionProgress: number;
  /** Layout computed from native aspect ratio, used for calibration screen. */
  remoteView: RemoteViewLayout | null;
  /** Wrist blade trails for the hand cursor overlay during gameplay. */
  bladeTrails: Map<string, TrailPoint[]>;
}

export function createIqInitialState(): IqDisplayState {
  return {
    phase: 'lobby',
    score: 0,
    progress: '',
    timeLeft: null,
    question: '',
    answers: [],
    labels: [],
    answerTextSize: 0.05,
    calibNormPoints: new Map(),
    detectionProgress: 0,
    remoteView: null,
    bladeTrails: new Map(),
  };
}
